import Sentry from 'util/sentry';
import { sendDeviceInfoService, EVENT } from 'analytics';
import { APP_RELEASE } from 'util/constants';

const getIpAddress = async () => {
    try {
        const response = await fetch('https://api64.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (err) {
        Sentry.captureException(err, { message: 'Error al obtener dirección IP' });
        return null;
    }
};

const sendDeviceInfo = async (event = EVENT.KEY.INIT) => {
    const uaData = navigator.userAgentData
        ? await navigator.userAgentData.getHighEntropyValues([
            "architecture",
            "model",
            "platform",
            "platformVersion",
            "uaFullVersion",
        ])
        : null;

    const ipAddress = await getIpAddress();
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const connection = navigator.connection || null;

    const model = uaData && uaData.model ? uaData.model : "PC/Desktop";
    const brand = uaData && uaData.model ? uaData.model.split(" ")[0] : uaData?.platform || "Desconocido";

    const payload = {
        storeVersion: APP_RELEASE,
        appVersion: APP_RELEASE,
        operatingSystem: uaData ? uaData.platform : navigator.userAgent,
        osVersion: uaData ? uaData.platformVersion : "Desconocido",
        model,
        modelReference: navigator.userAgent,
        ipAddress,
        geography: timeZone,
        brand,
        carrier: connection ? connection.effectiveType : "Desconocido",
        event
    };

    sendDeviceInfoService(payload)
};

export default sendDeviceInfo;
